import { Directive, Input,  HostListener } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationService } from './services/validation.service';

/*
    Returns error if email exists in db
*/

@Directive({
    selector: '[doesEmailExist]', 
   // providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => DoesEmailExistValidatorDirective), multi: true }]
})
export class DoesEmailExistValidatorDirective  {

    @Input()
    doesEmailExist: AbstractControl;

    constructor(private validationService: ValidationService) {
    }

    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {
        if (!this.doesEmailExist.errors) {
            this.validationService.doesEmailExist(this.doesEmailExist.value).subscribe((output) => {
                if (output == true) {
                    this.doesEmailExist.setErrors({
                        "emailExists": true
                    });
                }                   
            });
        }
    }
}

